// src/pages/Home.js
import React, { useState } from "react";
import "../styles/pageContent.css";
import CategoryBar from "../components/CategoryBar";
import ProductGrid from "../components/ProductGrid";
import FilterBar from "../components/FilterBar";

function Home() {
  const [filter, setFilter] = useState("");

  return (
    <div className="page-container">
      <h1>Shop Now</h1>
      <p>Explore trending products.</p>
      
      {/* CategoryBar will call setFilter on click */}
      <CategoryBar onCategoryClick={(category) => setFilter(category)} />
      
      {/* Optional: Textual FilterBar */}
      <FilterBar onFilterChange={setFilter} />
      
      {/* ProductGrid filters products based on the selected filter */}
      <ProductGrid filter={filter} />
    </div>
  );
}

export default Home;
